/* IndigeFish editorial theme - header state + mobile menu */
(function () {
  var nav = document.querySelector('.nav');
  if (nav) {
    var stuck = null;
    var onScroll = function () {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var now = y > 40;
      if (now === stuck) return;
      stuck = now;
      nav.classList.toggle('is-stuck', now);
      document.documentElement.classList.toggle('if-scrolled', now);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { stuck = null; onScroll(); }, { passive: true });
    document.addEventListener('shopify:section:load', onScroll);
  }

  var toggle = document.querySelector('.navtoggle');
  var links = document.querySelector('.nav__links');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      var open = links.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Close' : 'Menu';
    });
  }


  /* Background videos are expensive. Only the hero runs on load; the rest
     start when they scroll into view and stop again when they leave. */
  var bands = document.querySelectorAll('video[data-if-video]');
  if (bands.length) {
    if ('IntersectionObserver' in window) {
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      bands.forEach(function (v) { vo.observe(v); });
    } else {
      bands.forEach(function (v) { v.setAttribute('autoplay', ''); v.play(); });
    }
  }
})();
